import { render } from "./customer-form.vue?vue&type=template&id=9e3765e6"
import script from "./customer-form.vue?vue&type=script&lang=js"
export * from "./customer-form.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__